export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const LOADING_UPDATE_PASSWORD = 'LOADING_UPDATE_PASSWORD';
export const LOADING_PROFILE = 'LOADING_PROFILE';